export const APPLY_ALL_BASELINE_COLLECTION_ACKNOWLEDGE = 'apply-to-all-baseline-collection-acknowledge-confirmed';

export const IS_EXPAND_ONBOARDING_CHECKLIST = 'is-expand-onboarding-checklist';

export const IS_DISMISS_ONBOARDING_CHECKLIST = 'is-dismiss-onboarding-checklist';

export const IS_EXPAND_TEST_RUN_DAILY_REPORT = 'is-expand-test-run-daily-report';
